// routes
import { PATH_AUTH } from '../routes/paths';
// ----------------------------------------------------------------------

function jwtDecode(token) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join('')
  );

  return JSON.parse(jsonPayload);
}

// ----------------------------------------------------------------------

export const isValidToken = (accessToken) => {
  if (!accessToken) {
    return false;
  }

  try {
    const decoded = jwtDecode(accessToken);
    const currentTime = Date.now() / 1000;

    // Add a small buffer (30 seconds) to account for clock differences
    return decoded.exp > currentTime + 30;
  } catch (error) {
    console.error('Error validating token:', error);
    return false;
  }
};

// Enhanced token validation that also handles cleanup
export const validateTokenAndCleanup = (accessToken) => {
  const isValid = isValidToken(accessToken);

  if (!isValid && accessToken) {
    // Token exists but is invalid/expired - clean up
    localStorage.removeItem('accessToken');
    console.log('Invalid/expired token removed from storage');
  }

  return isValid;
};

// ----------------------------------------------------------------------

// Global timer reference for cleanup
let globalExpiredTimer = null;
let globalTimeoutTimer = null;

export const tokenExpired = (exp) => {
  // Clear any existing timers
  clearInterval(globalExpiredTimer);
  clearTimeout(globalTimeoutTimer);

  const currentTime = Date.now();
  const timeLeft = exp * 1000 - currentTime;

  // If token is already expired, handle immediately
  if (timeLeft <= 0) {
    handleTokenExpiry();
    return;
  }

  const updateTitleWithTimeLeft = (timeLeftInMillis) => {
    const timeLeftInMinutes = Math.max(Math.floor(timeLeftInMillis / 1000 / 60), 0);
    const timeLeftInSeconds = Math.max(Math.floor((timeLeftInMillis / 1000) % 60), 0);

    if (timeLeftInMinutes < 60) {
      document.title = `Token will expires in ${timeLeftInSeconds}s`;
    }
  };

  globalExpiredTimer = setInterval(() => {
    // Re-calculate time left to handle browser sleep/inactive periods
    const currentTimeNow = Date.now();
    const actualTimeLeft = exp * 1000 - currentTimeNow;

    if (actualTimeLeft <= 0) {
      handleTokenExpiry();
      return;
    }

    if (actualTimeLeft > 0) {
      updateTitleWithTimeLeft(actualTimeLeft);
    }
  }, 30000);

  globalTimeoutTimer = setTimeout(() => {
    handleTokenExpiry();
  }, timeLeft);
};

// Centralized token expiry handler
const handleTokenExpiry = () => {
  clearInterval(globalExpiredTimer);
  clearTimeout(globalTimeoutTimer);

  alert('Your session has expired. Please log in again.');
  localStorage.removeItem('accessToken');
  document.title = 'AUSL Bologna'; // Reset title
  window.location.href = PATH_AUTH.root;
};

// Clean up timers when needed
export const clearTokenTimers = () => {
  clearInterval(globalExpiredTimer);
  clearTimeout(globalTimeoutTimer);
  globalExpiredTimer = null;
  globalTimeoutTimer = null;
};

// ----------------------------------------------------------------------

export const setSession = (accessToken) => {
  if (accessToken) {
    // Validate token before setting session
    if (!isValidToken(accessToken)) {
      console.error('Attempting to set session with invalid token');
      localStorage.removeItem('accessToken');
      return;
    }

    localStorage.setItem('accessToken', accessToken);
    const { exp } = jwtDecode(accessToken);
    tokenExpired(exp);
  } else {
    localStorage.removeItem('accessToken');
    clearTokenTimers(); // Clean up any running timers
    document.title = 'AUSL Bologna'; // Reset title
  }
};
